"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toI8601 = exports.is8601 = exports.ISO8601 = void 0;
var moment_1 = __importDefault(require("moment"));
var zod_1 = require("zod");
exports.ISO8601 = zod_1.z.string().refine(function (date) { return (0, moment_1.default)(date, moment_1.default.ISO_8601, true).isValid(); });
var is8601 = function (date) { return exports.ISO8601.safeParse(date).success; };
exports.is8601 = is8601;
/**
 *
 * @param  {string | number | Date } arg - The date to convert to ISO-8601
 * @return {string} ISO-8601 string
 * @throws {Error} - if the date is invalid
 */
var toI8601 = function (arg) {
    if (arg === void 0) { arg = (0, moment_1.default)(); }
    if (!moment_1.default.isMoment(arg) && (0, moment_1.default)(new Date(arg)).isValid()) {
        return (0, moment_1.default)(arg).toISOString();
    }
    throw new Error("Unable to convert ".concat(arg, " to ISO-8601"));
};
exports.toI8601 = toI8601;
